import toast from 'react-hot-toast';
import secureAxios from '../secure_axios';

const baseUrl = 'tipo-relatorio'

async function servGetTiposRelatorioPorCpf() {
    try {
        const response = await secureAxios.get(`${baseUrl}/por-cpf`)
        return response.data
    } catch (error) {
        toast.error(error.message || 'Erro ao buscar tipos de relatório.')
        console.error(error);
        throw error
    }
}

export {
    servGetTiposRelatorioPorCpf
}